"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainButtons = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _EditButton = require("./EditButton");
var _ReservationButton = require("./ReservationButton");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var MainButtons = function MainButtons(props) {
  var EditButton = props.editButtonComponent || _EditButton.EditButton;
  var ReservationButton = props.reservationButtonComponent || _ReservationButton.ReservationButton;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ReservationButton, _extends({}, props, {
    editButton: function editButton(props) {
      return /*#__PURE__*/_react.default.createElement(_core.Box, {
        component: _core.Grid,
        item: true,
        flex: 2
      }, /*#__PURE__*/_react.default.createElement(_core.Button, {
        fullWidth: true,
        variant: "contained",
        color: "primary",
        startIcon: /*#__PURE__*/_react.default.createElement(_core.Icon, null, "event_note"),
        onClick: props.onClick
      }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
        id: "disponibilit\xE9"
      })));
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    component: _core.Grid,
    item: true,
    flex: 1
  }, /*#__PURE__*/_react.default.createElement(EditButton, props, function (props) {
    return /*#__PURE__*/_react.default.createElement(_core.Button, {
      fullWidth: true,
      variant: "contained",
      color: "primary",
      startIcon: /*#__PURE__*/_react.default.createElement(_core.Icon, null, "edit"),
      onClick: props === null || props === void 0 ? void 0 : props.onClick
    }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "Edit"
    }));
  })));
};
exports.MainButtons = MainButtons;